import he from '../../i18n/he';

// A cost waiting to be charged on, on a job that does not bill yet, is not a card — its
// job is not an income unit — but the recording dialog needs the same few identity fields
// every card carries. This adapts one into that shape rather than teaching the dialog a
// second one. Pure; nothing here fetches or computes money.
export const rowAsCard = (row) => ({
  kind: 'job',
  id: row.jobId,
  title: row.jobTitle,
  clientName: row.clientName,
  issuingPartnerId: null,
  monthlyAmount: null,
});

// What a charge with no month is called on the screen: a project's price by that name, an
// extra charge by its own (required) description, a job's charge as a charge. Display only.
export const chargeLabel = (row) => {
  if (row.origin === 'auto_project') return he.projects.price;
  return row.description || he.moneyScreen.item.jobCharge;
};
